import { tCustomer } from "../data/Customers";
import './CustomerFeedbackPopup.css';

interface CustomerReportPopupProps {
  customers: tCustomer[];
  sprint: number;
  closeCustomerReportCallback: () => void;
}

export default function CustomerReportPopup(props: CustomerReportPopupProps) {
  return (
    <div className="popup-overlay">
      <div className={`customer-feedback-popup-modal`}>
        <h3>📋 Customer Report</h3>
        <table className="feedback-table">
          <thead>
            <tr>
              <th>Company</th>
              <th>Status</th>
              <th>Venues</th>
              <th>Revenue</th>
            </tr>
          </thead>
          <tbody>
            {props.customers.map((customer, index) => {
              return (
                <tr key={index}>
                  <td>{customer?.icon} {customer?.name}</td>
                  <td>
                    <span className={`status-tag ${customer?.isCustomer ? 'customer' : customer.available <= props.sprint ? 'prospect' : 'not-interested'}`}>
                      {customer?.isCustomer ? 'Customer' : customer.available <= props.sprint ? 'Prospect' : 'No Interest'}
                    </span>
                  </td>
                  <td>{customer?.numberOfSites} / {customer?.maxSites}</td>
                  <td>£{customer?.paymentPerSprint.toFixed(2)}</td>
                </tr>
              )
            })}
          </tbody>
        </table>
        <button className="close-button" onClick={props.closeCustomerReportCallback}>Close</button>
      </div>
    </div>
  );
}
